<ion-grid [ngClass]="platformService?.platformType">
  <ion-row
    data-cy="seller-showcase-promotions-header-row"
    class="header-row"
    [class.touch]="platformService?.isTouchExperience$ | async"
  >
    <ion-col
      data-cy="seller-showcase-promotions-search-within-column"
      [size]="
        platformService?.platformType !== platformService?.platformEnum?.mobile
          ? 3
          : 5
      "
    >
      <ion-searchbar
        data-cy="seller-showcase-promotions-search-within-input"
        mode="md"
        class="search"
        placeholder="{{
          (platformService?.platformType !==
          platformService?.platformEnum?.mobile
            ? 'i18n.sellerShowcasePage.search'
            : 'i18n.common.search'
          ) | translate
        }}"
        [disabled]="!allProductsAvailable"
        [debounce]="searchWithinDebounceTime"
        [(ngModel)]="searchWithinKey"
        (ionInput)="!searchWithinKey ? resetSearchWithin() : searchWithin()"
        (ionClear)="resetSearchWithin()"
      ></ion-searchbar>
    </ion-col>
    <ion-col
      [size]="
        platformService?.platformType !== platformService?.platformEnum?.mobile
          ? 9
          : 7
      "
    >
      <div class="filter-clear-buttons">
        <app-sort-and-filter-button
          [sortAndFilterText]="'i18n.sellerShowcasePage.filter'"
          [sortAndFilterCount]="this.filtersApplied"
          [disabled]="!allProductsAvailable"
          (openSortAndFilterListModalEmitter)="handleOpenFilterModal()"
          (clearSortAndFilterListModalEmitter)="handleClearAllFilters()"
        ></app-sort-and-filter-button>
      </div>
    </ion-col>
  </ion-row>
  <ng-container
    *ngFor="
      let divisionalPromotion of divisionalPromotions;
      let i = index;
      trackBy: trackBySort
    "
  >
    <app-seller-showcase-divisional-promotion
      [divisionalPromotion]="divisionalPromotion"
      [sectionHeaders]="sectionHeaders"
      [isOnline]="isOnline"
      [pricingDisabled]="pricingDisabled"
      (updateExpansionEventEmitter)="handleUpdateExpansionEvent($event)"
      (updateSortEventEmitter)="handleUpdateSortEvent($event)"
      (ellipsisClickEmitter)="handleEllipsisClick($event)"
      (promotionalProductClickEmitter)="handleProductClick($event)"
      (changeQuantityEmitter)="handleQuantityChange($event)"
    >
    </app-seller-showcase-divisional-promotion>
  </ng-container>
</ion-grid>
